import type { InjectionKey, Ref } from 'vue';
import type { License } from '@/entities/Entities';

export type GlobalLicenseFilter = {
  boxType: string | null
  licenseId: string | null
};

export const globalLicenseFilterKey = Symbol('jk/globalLicenseFilterKey') as InjectionKey<Ref<GlobalLicenseFilter>>;

export default globalLicenseFilterKey;
